import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import styles from "./RightDrawer.module.scss";

export default function RightDrawer({
  isOpen,
  onClose,
  title,
  children,
  width = "520px",       // tu peux passer "420px", "40vw", etc.
  closeOnOverlay = true, // click overlay -> close
  showClose = true,
}) {
  const { t } = useTranslation();
  // ESC pour fermer
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  // lock scroll body
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={styles.overlay}
      onClick={closeOnOverlay ? onClose : undefined}
      aria-hidden="true"
    >
      <aside
        className={styles.drawer}
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title || t("common.panel")}
      >
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>

          {showClose && (
            <button type="button" className={`${styles.closeBtn} has-tooltip`} onClick={onClose} aria-label={t("common.close")}>
              <span aria-hidden="true">&times;</span>
            </button>
          )}
        </div>

        <div className={styles.body}>{children}</div>
      </aside>
    </div>,
    document.body
  );
}
